export const PERMISSIONS = {
  // ── Administración ──
  ACCOUNTS: "ACCOUNTS", // Cuentas de clientes
  ADMIN_GOD: "ADMIN_GOD", // Administrador general (GOD)
  DEVELOPER: "DEVELOPER", // Desarrollador
  USERS: "USERS", // Usuarios

  // ── Carburaciones ──
  CARBURETIONS: "CARBURETIONS", // Módulo de carburaciones
  CARBURATION_UPDATE_DATE: "CARBURATION-UPDATE-DATE", // Carburaciones - actualizar fecha
  CARBURATIONS_FILLING_ORDER_VISIBLE: "CARBURATIONS-FILLING-ORDER-VISIBLE", // Carburaciones - Ver orden de llenado

  // ── Catálogos ──
  CATALOG_UNITS_EDIT_TIPO: "CATALOG-UNITS-EDIT-TIPO", // Catálogos - tipos (unidad, entrega, llenado)
  CATALOG_UNITS_EDIT_CAPACITY: "CATALOG-UNITS-EDIT-CAPACITY", // Catálogos - capacidad de unidad
  CATALOGS: "CATALOGS", // Módulo de catálogos
  CATALOGS_ACCOUNTING_ACCOUNTS: "CATALOGS-ACCOUNTING-ACCOUNTS", // Catálogos - cuenta contable
  CATALOGS_ACCOUNTING_ACCOUNTS_EDIT: "CATALOGS-ACCOUNTING-ACCOUNTS-EDIT", // Catálogos - edición - cuenta contable
  CATALOGS_ACCOUNTING_ACCOUNTS_DELETE: "CATALOGS-ACCOUNTING-ACCOUNTS-DELETE", // Catálogos - eliminación - cuenta contable
  CATALOGS_CONCEPT_BONIFICATION: "CATALOGS-CONCEPT-BONIFICATION", // Catálogos - concepto bonificación
  CATALOGS_CONDITIONS_COMER: "CATALOGS-CONDITIONS-COMER", // Catálogos - condiciones comerciales
  CATALOGS_CONTRACTS: "CATALOGS-CONTRACTS", // Catálogos - contratos
  CATALOGS_FLOTILLA: "CATALOGS-FLOTILLA", // Catálogos - flotilla
  CATALOGS_NFC_TAG: "CATALOGS-NFCTAG", // Catálogos - tag NFC
  CATALOGS_PG: "CATALOGS-PG", // Catálogos - público general
  CATALOGS_PRODUCTS: "CATALOGS-PRODUCTS", // Catálogos - productos
  CATALOGS_RELATIONSHIP_ACCOUNTING_ACCOUNTS: "CATALOGS-RELATIONSHIP-ACCOUNTING-ACCOUNTS", // Catálogos - relación cuenta contable
  CATALOGS_RELATIONSHIP_ACCOUNTING_ACCOUNTS_EDIT: "CATALOGS-RELATIONSHIP-ACCOUNTING-ACCOUNTS-EDIT", // Catálogos - edición - relación cuenta contable
  CATALOGS_RELATIONSHIP_ACCOUNTING_ACCOUNTS_DELETE: "CATALOGS-RELATIONSHIP-ACCOUNTING-ACCOUNTS-DELETE", // Catálogos - eliminación - relación cuenta contable
  CATALOGS_STORAGE: "CATALOGS-STORAGE", // Cátalogos - almacenes
  CATALOGS_UNIT_DISPENSERS_EDIT: "CATALOGS-UNIT-DISPENSERS-EDIT", // Catálogos - dispensadores de unidad (crear/editar)
  CATALOGS_UNIT_EQUIPMENTS_EDIT: "CATALOGS-UNIT-EQUIPMENTS-EDIT", // Catálogos - equipo electrónico de unidad (asignar/editar)
  CATALOGS_STORAGE_DELETE: "CATALOGS-STORAGE-DELETE", // Cátalogos - almacenes - eliminar

  // ── Clientes ──
  CUSTOMER: "CUSTOMER", // Módulo de clientes
  CUSTOMER_CLIENT: "CUSTOMER-CLIENT", // Clientes - vista cliente
  CUSTOMER_COMMERCIAL: "CUSTOMER-COMMERCIAL", // Clientes - vista comercial
  CUSTOMER_CONNECT: "CUSTOMER-CONNECT", // Clientes - conexión
  CUSTOMER_CREDIT_CONDITIONS_EDIT: "CUSTOMER-CREDIT-CONDITIONS-EDIT", // Clientes - editar condiciones de crédito (toda la sección; solo lectura para clientes de crédito con código ERP)
  CUSTOMER_CYCLES: "CUSTOMER-CYCLES", // Clientes - ciclos
  CUSTOMER_DISCOUNT_TYPE: "CUSTOMER-DISCOUNT-TYPE", // Clientes - tipo de descuento
  CUSTOMER_DOCUMENTATION: "CUSTOMER-DOCUMENTATION", // Clientes - documentación
  CUSTOMER_GIRO: "CUSTOMER-GIRO", // Clientes - giro
  CUSTOMER_HIDE_COST: "CUSTOMER-HIDE_COST", // Clientes - ocultar costos
  CUSTOMER_PIN: "CUSTOMER-PIN", // Clientes - pin
  CUSTOMER_SERVICES: "CUSTOMER-SERVICES", // Clientes - servicios
  CUSTOMERS_WHOLESALER: "CUSTOMERS-WHOLESALER", // Clientes mayoristas
  CUSTOMERS_WHOLESALER_FIND: "CUSTOMERS-WHOLESALER-FIND", // Clientes mayoristas - búsqueda
  ACCOUNT_WEB_VERIFY: "ACCOUNT-WEB-VERIFY", // Cuentas - verificación de cliente web

  // ── Coberturas ──
  COVERAGES: "COVERAGES", // Módulo de coberturas
  COVERAGES_ASSIGN: "COVERAGES_ASSIGN", // Coberturas - asignación
  COVERAGE_GROUPS: "COVERAGE_GROUPS", // Grupos de coberturas

  // ── Comodatos ──
  COMMODATOS: "COMMODATOS", // Comodatos
  COMMODATOS_DELETE: "COMMODATOS-DELETE", // Comodatos - eliminar
  COMMODATOS_TANK: "COMMODATOS-TANK", // Comodatos - tanque

  // ── CRM ──
  CRM: "CRM", // Módulo CRM
  CRM_EQUIVALENCE_ERP_GN4: "CRM-EQUIVALENCE-ERP-GN4", // CRM - equivalencia ERP GN4
  CRM_EQUIVALENCE_ERP_GN4_CONDITIONS: "CRM-EQUIVALENCE-ERP-GN4-CONDITIONS", // CRM - equivalencia condiciones ERP GN4
  CRM_EQUIVALENCE_ERP_GN4_CONDITIONS_WHOLE: "CRM-EQUIVALENCE-ERP-GN4-CONDITIONS-WHOLE", // CRM - equivalencia condiciones completo ERP GN4
  CRM_UNLOCK_ACCOUNTS_SERVICE: "CRM-UNLOCK-ACCOUNTS-SERVICE", // CRM - desbloquear cuentas servicio
  CRM_UNLOCK_ACCOUNTS_SERVICE_AR: "CRM-UNLOCK-ACCOUNTS-SERVICE-AR", // CRM - desbloquear cuentas servicio A/R

  // ── Depósitos ──
  DEPOSIT: "DEPOSIT", // Módulo de depósitos
  DEPOSIT_DELETE: "DEPOSIT-DELETE", // Depósitos - eliminar

  // ── Dotaciones / Liquidaciones ──
  ENDOWMENTS: "ENDOWMENTS", // Dotaciones
  ENDOWMENTS_CONDONATION: "ENDOWMENTS-CONDONATION", // Dotaciones - condonación
  ENDOWMENTS_DEL_NOTE: "ENDOWMENTS-DEL-NOTE", // Dotaciones - eliminar nota
  ENDOWMENTS_FILLING_ORDER_RENEW: "ENDOWMENTS-FILLING-ORDER-RENEW", // Dotaciones - renovar orden de llenado
  ENDOWMENTS_REASSIGNMENT_FOLIO: "ENDOWMENTS-REASSIGNMENT-FOLIO", // Dotaciones - reasignación de folio a nota de crédito
  ENDOWMENTS_ORDERS_VIEW: "ENDOWMENTS-ORDERS-VIEW", // Dotaciones - ver órdenes
  ENDOWMENTS_SETTLEMENTS: "ENDOWMENTS-SETTLEMENTS", // Dotaciones - liquidaciones
  ENDOWMENTS_SETTLEMENTS_OTHER_PRODUCTS: "ENDOWMENTS-SETTLEMENTS-OTHER-PRODUCTS", // Dotaciones - liquidación otros productos
  ENDOWMENTS_SETTLEMENTS_REGENERATE_PDF: "ENDOWMENTS-SETTLEMENTS-REGENERATE-PDF", // Dotaciones - regenerar PDF
  ENDOWMENTS_SETTLEMENTS_REPLACE: "ENDOWMENTS-SETTLEMENTS-REPLACE", // Dotaciones - sustituir liquidación
  ENDOWMENTS_CHANGE_DATE: "ENDOWMENTS_CHANGE_DATE", // Dotaciones - cambiar fecha de notas en liquidaciones
  LIQUIDATION_UPDATE_DATE: "LIQUIDATION_UPDATE_DATE", // Liquidaciones - actualizar fecha

  // ── Edificios / Departamentos ──
  APPLY_PAYMENT: "APPLY-PAYMENT", // Aplicar pago
  BUILDINGS: "BUILDINGS", // Edificios
  CONNECT_APARTMENT_SERVICE: "CONNECT-APARTMENT-SERVICE", // Conectar servicio departamento
  DISCONNECT_APARTMENT_SERVICE: "DISCONNECT-APARTMENT-SERVICE", // Desconectar servicio departamento
  REASSIGN_PAYMENT: "REASSIGN-PAYMENT", // Reasignar pago

  // ── Equipo electrónico ──
  ELECTRONIC_EQUIPMENT_ADD: "ELECTRONIC-EQUIPMENT-ADD", // Equipo electrónico - agregar
  ELECTRONIC_EQUIPMENT_CATALOG: "ELECTRONIC-EQUIPMENT-CATALOG", // Catálogo de equipo electrónico
  ELECTRONIC_EQUIPMENT_DELETE: "ELECTRONIC-EQUIPMENT-DELETE", // Equipo electrónico - eliminar
  ELECTRONIC_EQUIPMENT_EDIT: "ELECTRONIC-EQUIPMENT-EDIT", // Equipo electrónico - editar

  // ── Estaciones ──
  STATION_PRICES: "STATION_PRICES", // Precios de estación
  STATIONS: "STATIONS", // Estaciones
  UPDATE_STATION_PRICE: "UPDATE_STATION_PRICE", // Actualizar precio de estación

  // ── Facturación ──
  INVOICES: "INVOICES", // Módulo de facturación
  INVOICES_CHANGE_PRICE_NOTES_STAMP: "INVOICES-CHANGE-PRICE-NOTES-STAMP", // Facturación - cambio de precio en timbrado
  INVOICES_ERP: "INVOICES-ERP", // Facturación ERP
  INVOICES_ERP_MIGRATION: "INVOICES-ERP-MIGRATION", // Facturación - migración ERP
  INVOICES_ERP_MIGRATION_5ALMILLAR: "INVOICES-ERP-MIGRATION-5ALMILLAR", // Facturación - migración ERP 5 al millar
  INVOICES_ERP_MIGRATION_CANCEL: "INVOICES-ERP-MIGRATION-CANCEL", // Facturación - cancelar migración ERP
  INVOICES_ERP_UPDATE_SAT: "INVOICES-ERP-UPDATE-SAT", // Facturación - actualización SAT
  INVOICES_CASH: "INVOICES-CASH", // Facturación de contado
  INVOICE_CASH_CONCEPT: "INVOICE_CASH_CONCEPT", // Facturación de contado - concepto específico (NODO: DESCRIPCION)
  INVOICE_CREDIT_CONCEPT: "INVOICE_CREDIT_CONCEPT", // Facturación de crédito - concepto específico (NODO: DESCRIPCION)
  INVOICES_GLOBAL: "INVOICES-GLOBAL", // Facturación global
  INVOICES_GLOBAL_DELETE: "INVOICES-GLOBAL-DELETE", // Facturación global - eliminar
  INVOICE_GLOBAL_VIEW: "INVOICE_GLOBAL_VIEW", // Facturación global - ver estatus (detalle de error)
  INVOICE_GLOBAL_JSON: "INVOICE_GLOBAL_JSON", // Facturación global - ver JSON enviado
  INVOICE_GLOBAL_PDFXML: "INVOICE_GLOBAL_PDFXML", // Facturación global - descargar XML/PDF
  INVOICES_PROMISSORY_NOTE: "INVOICES_PROMISSORY_NOTE", // Facturación - pagarés
  INVOICES_TRANSFER: "INVOICES-TRANSFER", // Facturación de traslado

  // ── Gastos ──
  EXPENSE: "EXPENSE", // Gastos

  // ── Integraciones ──
  INTEGRATIONS: "INTEGRATIONS", // Integraciones
  INTEGRATIONS_ANALYST: "INTEGRATIONS-ANALYST", // Integraciones - analista
  INTEGRATIONS_REQUESTER: "INTEGRATIONS-REQUESTER", // Integraciones - solicitante

  // ── Inventarios ──
  DIGITAL_INVENTORIES_ACTIONS: "DIGITAL-INVENTORIES-ACTIONS", // Inventario digital - acciones
  DIGITAL_INVENTORIES_DELETE: "DIGITAL-INVENTORIES-DELETE", // Inventario digital - eliminar
  DIGITAL_INVENTORIES_SYNC: "DIGITAL-INVENTORIES-SYNC", // Inventario digital - sincronizar
  DIGITAL_INVENTORY: "DIGITAL-INVENTORY", // Inventario digital
  INVENTORIES: "INVENTORIES", // Módulo de inventarios
  INVENTORIES_AWS_REAL: "INVENTORIES-AWS-REAL", // Inventarios - AWS real
  INVENTORIES_CLOSE: "INVENTORIES-CLOSE", // Inventarios - cierre
  INVENTORIES_CONTROL: "INVENTORIES-CONTROL", // Inventarios - control
  INVENTORIES_CONTROL_CREATE: "INVENTORIES-CONTROL-CREATE", // Inventarios - control crear
  INVENTORIES_CONTROL_DELETE: "INVENTORIES-CONTROL-DELETE", // Inventarios - control eliminar
  INVENTORIES_CONTROL_DIGITAL_MOVEMENTS: "INVENTORIES-CONTROL-DIGITAL-MOVEMENTS", // Inventarios - movimientos digitales
  INVENTORIES_CONTROL_DIGITAL_MOVEMENTS_A_R: "INVENTORIES-CONTROL-DIGITAL-MOVEMENTS-A_R", // Inventarios - movimientos digitales A/R
  INVENTORIES_CONTROL_DIGITAL_UPDATE: "INVENTORIES-CONTROL-DIGITAL-UPDATE", // Inventarios - control digital actualizar
  INVENTORIES_CONTROL_EDIT: "INVENTORIES-CONTROL-EDIT", // Inventarios - control editar
  INVENTORIES_CONTROL_RECALCULATE: "INVENTORIES-CONTROL-RECALCULATE", // Inventarios - control recalcular
  INVENTORIES_CONTROL_VIEW: "INVENTORIES-CONTROL-VIEW", // Inventarios - control ver
  INVENTORIES_CPV: "INVENTORIES-CPV", // Inventarios - CPV
  INVENTORIES_CPV_REOPEN: "INVENTORIES-CPV-REOPEN", // Inventarios - CPV reabrir
  INVENTORIES_DEPOSIT: "INVENTORIES-DEPOSIT", // Inventarios - depósito
  INVENTORIES_SHIPMENTS_DELETE: "INVENTORIES-SHIPMENTS-DELETE", // Inventarios - eliminar embarques
  INVENTORIES_STATION: "INVENTORIES-STATION", // Inventarios - estación
  INVENTORIES_VOL: "INVENTORIES-VOL", // Inventarios - volumétricos
  INVENTORIES_XML: "INVENTORIES-XML", // Inventarios - XML
  INVENTORIES_XML_QUERYZATOR: "INVENTORIES-XML-QUERYZATOR", // Inventarios - XML queryzator
  INVENTORIES_HISTORY: "INVENTORIES-HISTORY", // Inventarios - ver historial de cambios
  INVENTORY_REOPEN: "INVENTORY_REOPEN", // Inventarios - reabrir

  // ── Mapa ──
  MAP: "MAP", // Mapa

  // ── Marketing ──
  CHAT: "CHAT", // Chat
  MARKETING: "MARKETING", // Marketing
  SURVEYS: "SURVEYS", // Encuestas

  // ── Movimientos de gas ──
  MOVEMENTS_VIEW: "MOVEMENTS-VIEW", // Movimientos de gas
  MOVEMENTS_VIEW_A_R: "MOVEMENTS-VIEW-A-R", // Movimientos de gas - aprobar/rechazar
  MOVEMENTS_VIEW_CONFIRM: "MOVEMENTS-VIEW-CONFIRM", // Movimientos de gas - confirmar
  MOVEMENTS_VIEW_DELETE: "MOVEMENTS-VIEW-DELETE", // Movimientos de gas - eliminar
  MOVEMENTS_VIEW_EDIT: "MOVEMENTS-VIEW-EDIT", // Movimientos de gas - editar
  NOTES_TRANSFER_CEDIS: "NOTES-TRANSFER-CEDIS", // Notas - transferencia CEDIS

  // ── On-premise ──
  ONPREMISE_CARBURATIONS: "ONPREMISE-CARBURATIONS", // On-premise - carburaciones
  ONPREMISE_CATALOG_USER: "ONPREMISE-CATALOG-USER", // On-premise - catálogo usuario
  ONPREMISE_CATALOGS: "ONPREMISE-CATALOGS", // On-premise - catálogos
  ONPREMISE_ORDERS: "ONPREMISE-ORDERS", // On-premise - pedidos
  ONPREMISE_PRINTERS: "ONPREMISE-PRINTERS", // On-premise - impresoras
  ONPREMISE_SETTLEMENTS: "ONPREMISE-SETTLEMENTS", // On-premise - liquidaciones
  ONPREMISE_USER: "ONPREMISE_USER", // On-premise - usuario

  // ── Pedidos ──
  ORDER_FILLING: "ORDER-FILLING", // Orden de llenado
  ORDERS: "ORDERS", // Módulo de pedidos
  ORDERS_EDIT_ORIGIN: "ORDERS-EDIT-ORIGIN", // Pedidos - editar origen
  ORDERS_FLOTILLA: "ORDERS-FLOTILLA", // Pedidos flotilla
  ORDERS_NOTES: "ORDERS-NOTES", // Pedidos - notas
  ORDERS_SUBSCRIPTION_APPROVE: "ORDERS-SUBSCRIPTION-APPROVE", // Pedidos - aprobar suscripción
  ORDERS_STATUS: "ORDERS_STATUS", // Pedidos - cambiar estatus
  ORDER_STATUS_DONE: "ORDER_STATUS_DONE", // Pedidos - cambiar estatus a Surtido
  ORDERSGRAPH: "ORDERSGRAPH", // Gráfica de pedidos

  // ── Pólizas ──
  POLICY_CREATE_EDIT: "POLICY-CREATE-EDIT", // Pólizas - crear/editar
  POLICY_DELETE: "POLICY-DELETE", // Pólizas - eliminar
  POLICY_VIEW: "POLICY-VIEW", // Pólizas - ver

  // ── Pre-nómina ──
  PREPAYROLL: "PREPAYROLL", // Pre-nómina
  PREPAYROLL_ADMIN: "PREPAYROLL-ADMIN", // Pre-nómina - administrador
  PREPAYROLL_MONITOR: "PREPAYROLL-MONITOR", // Pre-nómina - monitor

  // ── Compras ──
  PURCHASES: "PURCHASES", // Compras

  // ── Embarques ──
  DISOUNT_SHIPMENTS: "DISOUNT-SHIPMENTS", // Descuento en embarques

  // ── Impresoras ──
  PRINTERS: "PRINTERS", // Impresoras

  // ── Rentabilidad ──
  PROFIT_BUSINESS: "PROFIT_BUSINESS", // Rentabilidad de negocio

  // ── Reportes ──
  REPORTS: "REPORTS", // Módulo general de reportes
  REPORTS_ACCUMULATED_DISCOUNT: "REPORTS-ACCUMULATED-DISCOUNT", // Reporte Descuentos Acumulados
  REPORTS_ADVANCE_PAYMENTS: "REPORTS-ADVANCE-PAYMENTS", // Reporte de anticipos
  REPORTS_AUDIT_SETTLEMENTS: "REPORTS-AUDIT-SETTLEMENTS", // Reporte de liquidaciones auditoría
  REPORTS_BONIFICATIONS: "REPORTS-BONIFICATIONS", // Reporte de bonificaciones
  REPORTS_CARBURATION: "REPORTS-CARBURATION", // Reporte de carburaciones
  REPORTS_CARBURETION3: "REPORTS-CARBURETION3", // Reporte de carburaciones 3
  REPORTS_CASH_DISCOUNT_CUSTOMERS: "REPORTS-CASH-DISCOUNT-CUSTOMERS", // Reporte de clientes de contado con descuento
  REPORTS_CASH_RECONCILIATION: "REPORTS-CASH-RECONCILIATION", // Reporte de conciliación de efectivo
  REPORTS_COMODATA: "REPORTS-COMODATA", // Reporte de comodatos
  REPORTS_CREDIT: "REPORTS-CREDIT", // Reporte de créditos
  REPORTS_CREDIT_MIGRATION: "REPORTS-CREDIT-MIGRATION", // Reporte de migración de créditos
  REPORTS_DAY_GN4: "REPORTS-DAY-GN4", // Reporte del día GN4
  REPORTS_DEPOSITS: "REPORTS-DEPOSITS", // Reporte de depósitos
  REPORTS_DETAIL_INVENTORY: "REPORTS-DETAIL-INVENTORY", // Reporte detalle de inventario
  REPORTS_DETAILED_NOTES: "REPORTS-DETAILED-NOTES", // Reporte Detallado de Notas
  REPORTS_DIGITAL_INVENTORY: "REPORTS-DIGITAL-INVENTORY", // Reporte de inventario digital
  REPORTS_DISCOUNTS_RELATIONSHIP: "REPORTS-DISCOUNTS-RELATIONSHIP", // Reporte de relación de descuentos
  REPORTS_EXPENSES: "REPORTS-EXPENSES", // Reporte de gastos
  REPORTS_GLOBAL_SALES: "REPORTS-GLOBAL-SALES", // Reporte de ventas globales
  REPORTS_INVENTORY: "REPORTS-INVENTORY", // Reporte de inventario
  REPORTS_INVENTORY_PERCENTAGES: "REPORTS-INVENTORY-PERCENTAGES", // Reporte de Porcentajes de Inventario
  REPORTS_INVENTORY_STOCK: "REPORTS-INVENTORY-STOCK", // Reporte de Inventario existencias
  REPORTS_INVOICE_LIST: "REPORTS-INVOICE-LIST", // Reporte de listado de facturas
  REPORTS_INVOICE_RELATIONSHIP: "REPORTS-INVOICE-RELATIONSHIP", // Reporte de relación de facturas
  REPORTS_LOGINS: "REPORTS_LOGINS", // Reporte de inicios de sesión
  REPORTS_NATIONAL_NOTES: "REPORTS-NATIONAL-NOTES", // Reporte de notas nacionales
  REPORTS_PROGRESSIVE_APP: "REPORTS-PROGRESSIVE-APP", // Reporte de app progresivo
  REPORTS_RAPIDCANVAS: "REPORTS-RAPIDCANVAS", // Reporte RapidCanvas
  REPORTS_RESUME_DAY: "REPORTS-RESUME-DAY", // Reporte resumen del día
  REPORTS_RETENTIONS: "REPORTS-RETENTIONS", // Reporte Retenciones
  REPORTS_RETENTIONS_EXISTS: "REPORTS-RETENTIONS-EXISTS", // Reporte Salidas de Retenciones
  REPORTS_SALE_BY_MUNICIPALITY: "REPORTS-SALE-BY-MUNICIPALITY", // Reporte de venta por municipio
  REPORTS_SALES: "REPORTS-SALES", // Reporte de ventas
  REPORTS_SALES_BY_NOTE: "REPORTS-SALES-BY-NOTE", // Reporte de ventas por nota
  REPORTS_SALES_BY_ZONE_WHOLESALER: "REPORTS-SALES-BY-ZONE-WHOLESALER", // Reporte de Venta por zona mayoristas
  REPORTS_SALES_CATEGORY: "REPORTS-SALES-CATEGORY", // Reporte de ventas por categoría
  REPORTS_SALES_CUMULATIVE_GLOBAL: "REPORTS-SALES-CUMULATIVE-GLOBAL", // Reporte de venta global acumulada
  REPORTS_SALES_CUSTOMER: "REPORTS-SALES-CUSTOMER", // Reporte de ventas por cliente
  REPORTS_SETTLEMENTS: "REPORTS-SETTLEMENTS", // Reporte de liquidaciones
  REPORTS_SHIPMENTS: "REPORTS-SHIPMENTS", // Reporte de embarques
  REPORTS_SHIPMENTS_PERFORMANCE: "REPORTS-SHIPMENTS-PERFORMANCE", // Reporte Rendimientos de Embarque
  REPORTS_SPECIAL_UNITS: "REPORTS-SPECIAL-UNITS", // Reporte de Unidades Especiales
  REPORTS_SUBSTITUTION_SETTLEMENTS: "REPORTS-SUBSTITUTION-SETTLEMENTS", // Reporte Sustitución de Liquidaciones
  REPORTS_SUPERVISION: "REPORTS-SUPERVISION", // Reporte de supervisión
  REPORTS_TRANSFER_INVOICE: "REPORTS-TRANSFER-INVOICE", // Reporte de facturas de traslado
  REPORTS_UNIT_PERFORMANCE: "REPORTS-UNIT-PERFORMANCE", // Reporte Rendimiento de Unidades
  REPORTS_UNITS_WITH_PERMISSION: "REPORTS-UNITS-WITH-PERMISSION", // Reporte Unidades con Permiso
  REPORTS_SHIPMENTS_RETURNS: "REPORTS-SHIPMENTS-RETURNS", // Reporte de devoluciones de embarques
  REPORTS_INVOICES_GROUPED: "REPORTS-INVOICES-GROUPED", // Reporte Agrupado Listado de Facturación

  // ── Series ──
  SERIES: "SERIES", // Series

  // ── SGC ──
  SGC_CONFIG: "SGC-CONFIG", // Configuración SGC

  // ── Soporte ──
  SUPPORT: "SUPPORT", // Módulo de soporte
  SUPPORT_APP: "SUPPORT-APP", // Soporte - aplicación
  SUPPORT_DISPENSER_USER: "SUPPORT-DISPENSER-USER", // Soporte - usuario dispensador
  SUPPORT_MUNICIPALITIES: "SUPPORT-MUNICIPALITIES", // Soporte - municipios
  SUPPORT_MUNICIPALITIES_DELETE: "SUPPORT-MUNICIPALITIES-DELETE", // Soporte - eliminar municipios
  SUPPORT_PERIOD_EXPENSES: "SUPPORT-PERIOD-EXPENSES", // Soporte - gastos del periodo
  SUPPORT_PRICES: "SUPPORT-PRICES", // Soporte - precios
  SUPPORT_PRICES_CHANGE: "SUPPORT-PRICES-CHANGE", // Soporte - cambio de precios
  SUPPORT_STATIONS_CONFIGURATIONS_DIGITAL: "SUPPORT-STATIONS-CONFIGURATIONS-DIGITAL", // Soporte - configuraciones digitales de estación
  SUPPORT_SYNC_CATALOG_APRO: "SUPPORT-SYNC-CATALOG-APRO", // Soporte - sincronizar catálogo APRO

  // ── Supervisión ──
  SUPERVISION: "SUPERVISION", // Supervisión
  SUPERVISION_DECRYPT: "SUPERVISION-DECRYPT", // Supervisión - desencriptar

  // ── Almacenamiento ──
  STORAGE_AWS_UUID: "STORAGE_AWS_UUID", // Almacenamiento - AWS UUID
  STORAGE_DEVICE_ID: "STORAGE_DEVICE_ID", // Almacenamiento - ID dispositivo

  // ── IoT Devices ──
  IOT_DEVICES: 'IOT-DEVICES-VIEW',
  IOT_DEVICES_CREATE: 'IOT-DEVICES-CREATE',
  IOT_DEVICES_EDIT: 'IOT-DEVICES-EDIT',
  IOT_DEVICES_ASSIGN: 'IOT-DEVICES-ASSIGN',

  // ── Tanques ──
  TANK_AWS_UUID: "TANK_AWS_UUID", // Tanques - AWS UUID
  TANK_DEVICE_ID: "TANK_DEVICE_ID", // Tanques - ID dispositivo
  TANKS: "TANKS", // Tanques
  TANKS_RELATIONS: "TANKS-RELATIONS", // Tanques - relaciones

  // ── Unidades ──
  UNIT_ADD_EMPLOYEE: "UNIT_ADD_EMPLOYEE", // Unidades - agregar empleado
  UNIT_CATALOG_DEL: "UNIT_CATALOG_DEL", // Catálogo de unidades - eliminar
  UNIT_CATALOG_EDIT: "UNIT_CATALOG_EDIT", // Catálogo de unidades - editar
  UNIT_CATALOG_PAYMENT_TERMINAL: "UNIT-CATALOG-PAYMENT-TERMINAL", // Catálogo de unidades - activar/desactivar terminal bancaria
  UNIT_CATALOG_DISCOUNT: "UNIT_CATALOG_DISCOUNT", // Unidades - actualizar descuento por litro
  UNIT_CONFIG: "UNIT_CONFIG", // Unidades - configuración
  UNIT_CONST_CENTER: "UNIT_CONST_CENTER", // Unidades - centro de costos
  UNIT_DISPENSER: "UNIT_DISPENSER", // Unidades - dispensador
  UNIT_FLOWMETER_UPDATE: "UNIT_FLOWMETER_UPDATE", // Unidades - actualizar flujómetro
  UNIT_GEOFENCING: "UNIT_GEOFENCING", // Unidades - geocercas
  UNIT_MAINTENANCE: "UNIT-MAINTENANCE", // Unidades - mantenimiento
  UNIT_MANUAL_CONF: "UNIT-MANUAL-CONF", // Unidades - configuración manual
  UNIT_NFC_TAG: "UNIT-NFC-TAG", // Unidades - tag NFC
  UNIT_NFC_TAG_DELETE: "UNIT-NFC-TAG-DELETE", // Unidades - eliminar tag NFC
  UNIT_OPERATIVE: "UNIT_OPERATIVE", // Unidades - operativo
  UNIT_OPERATIVE_STATION: "UNIT-OPERATIVE-STATION", // Unidades - operativo estación
  UNIT_PIPE_CONDITIONS: "UNIT_PIPE_CONDITIONS", // Unidades - condiciones de pipas
  UNIT_PLATFORM_CONDITIONS: "UNIT_PLATFORM_CONDITIONS", // Unidades - condiciones de plataforma
  UNIT_STATION_TRANSFER: "UNIT_STATION_TRANSFER", // Unidades - transferencia de estación
  UNIT_SYNC: "UNIT_SYNC", // Unidades - sincronización
  UNIT_TAGS: "UNIT_TAGS", // Unidades - tags
  UNIT_VERSION: "UNIT-VERSION", // Unidades - versión
  UNITS: "UNITS", // Módulo de unidades
  UNITS_CATALOG: "UNITS_CATALOG", // Catálogo de unidades
  UNITS_CATALOG_WHOLESALER_VIEW: "UNITS_CATALOG-WHOLESALER-VIEW", // Catálogo unidades - mayorista ver
  UNITS_CATALOG_WHOLESALER_EDIT: "UNITS_CATALOG-WHOLESALER-EDIT", // Catálogo unidades - mayorista editar
  UNITS_IMEI: "UNITS-IMEI", // Unidades - IMEI
  UNITS_INVENTORY_WHOLE: "UNITS-INVENTORY-WHOLE", // Unidades - Agregar unidad a inventario
  UNITS_INVOICE_TRANSFER_EDIT: "UNITS-INVOICE-TRANSFER-EDIT", // Unidades - Factura de traslado
  UNITS_VISIBLE_FILLING_ORDER: "UNITS-VISIBLE-FILLING-ORDER", // Unidades - orden de llenado visible
  UNITS_WHOLESALER_CUSTOMERS: "UNITS-WHOLESALER-CUSTOMERS", // Unidades - clientes mayoristas
  UNITS_WHOLESALER_CONDITIONS: "UNITS-WHOLESALER-CONDITIONS", // Unidades - condiciones de mayoristas
  UNITS_WHOLESALER_CONDITIONS_GIRO: "UNITS-WHOLESALER-CONDITIONS-GIRO", // Unidades - giro -condiciones mayoristas

  // ── Factura de Traslado (Carta Porte) ──
  TRANSFER_RENEW: "TRANSFER-RENEW", // Ver, generar y descargar Carta Porte desde inicio/fin de ruta

  // ── Historial ──
  HISTORY: "HISTORY", // Historial

  // ── Retenciones Comisionistas ──
  WITHHOLDINGS: "WITHHOLDINGS", // Vista de retenciones
  WITHHOLDINGS_A_R: "WITHHOLDINGS-A-R", // Aceptar o rechazar una salida de retención
  WITHHOLDINGS_CLOSING_CREATE: "WITHHOLDINGS-CLOSING-CREATE", // Crear un cierre de mes de retenciones comisionistas
  WITHHOLDINGS_CLOSING_EXPENSE: "WITHHOLDINGS-CLOSING-EXPENSE", // Crear un gasto de salida de retención en cierre de mes
  WITHHOLDINGS_CLOSING_VIEW: "WITHHOLDINGS-CLOSING-VIEW", // Vista cierre de mes de retenciones comisionistas
  WITHHOLDINGS_CREATE: "WITHHOLDINGS-CREATE", // Crear una salida de retención
  WITHHOLDINGS_DELETE: "WITHHOLDINGS-DELETE", // Eliminar una salida de retención
  WITHHOLDINGS_DELIVERY: "WITHHOLDINGS-DELIVERY", // Entregar una retención
  WITHHOLDINGS_DEPARTURES: "WITHHOLDINGS-DEPARTURES", // Vista de salidas retenciones de comisionistas
  WITHHOLDINGS_PDF: "WITHHOLDINGS-PDF", // Subir al bucket el PDF de la entrega de retención
  WITHHOLDINGS_SPECIAL_UNITS: "WITHHOLDINGS-SPECIAL-UNITS", // Vista de unidades especiales dentro de comisionistas
  WITHHOLDINGS_SPECIAL_UNITS_CREATE: "WITHHOLDINGS-SPECIAL-UNITS-CREATE", // Crear movimiento de unidades especiales
  WITHHOLDINGS_SPECIAL_UNITS_DELETE: "WITHHOLDINGS-SPECIAL-UNITS-DELETE", // Eliminar movimiento de unidades especiales
};
